export enum TermOfContractEnum {
    OneYear = 1,
    AutoRenew = 2,
    Revised = 3,
    Continuation = 4,
}
